module.exports = __webpack_public_path__ + "static/media/calendar-wallet.548fc07a.svg";